module.exports = __webpack_public_path__ + "static/media/Paper_Thumb_1.99174071.jpg";